import ButtonExportExcel from '../../../../components/ui/ButtonExportExcel'
import { exportExcelAccountGuest } from '../../../../service/ExportExcelAccountGuest'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
export default function ExportExcelAccountGuest() {
  const handleExport = async () => {
    try {
      showLoadingToast('Đang tải..', toastKey.ACCOUNT.GUEST.EXPORT)
      const res = await exportExcelAccountGuest.export()
      if (!res.ok) {
        showErrorToast('Xuất excel thất bại!', toastKey.ACCOUNT.GUEST.EXPORT)
      }
      const blob = await res.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const now = new Date()

      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      const formatted = `${day}${month}${year}${hours}${minutes}${seconds}`
      a.download = `list_account_guest_${formatted}.xlsx`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
      showSuccessToast('Xuất excel thành công', toastKey.ACCOUNT.GUEST.EXPORT)
    } catch (error) {
      showErrorToast({
        message: 'Xuất excel thất bại!',
        error: error.message,
        toastId: toastKey.ACCOUNT.GUEST.EXPORT,
      })
    }
  }
  return <ButtonExportExcel onClick={handleExport} />
}
